import React, { PureComponent } from 'react';
import strings from 'helper/localization/localization';

export default class SignupPassword extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      password: '',
      errorMessage: null,
    };

    this.updateDetails = this.props.updateDetails;
    this.toNextStep = this.toNextStep.bind(this);
    this.passwordChanged = this.passwordChanged.bind(this);
  }

  toNextStep(e) {
    e.preventDefault();
    this.setState({ errorMessage: null });

    if (this.state.password.length < 8) {
      this.setState({ errorMessage: strings.passwordMustBeLong });
    } else {
      this.updateDetails('password', this.state.password);
    }
  }

  passwordChanged(e) {
    this.setState({ password: e.target.value });
  }

  render() {
    const errorMessage = this.state.errorMessage ?
      <p className="text-danger">{this.state.errorMessage}</p> : null;

    return (
      <form>
        <div className="form-group">
          <label htmlFor="signup--password">{strings.enterAPassword}</label>
          <input
            type="password"
            className="form-control"
            id="signup--password"
            onChange={this.passwordChanged}
            placeholder={strings.passwordMinEight}
            autoFocus
          />
        </div>
        { errorMessage }
        <button
          type="submit"
          className="btn btn-outline-primary btn-lg btn-block"
          onClick={this.toNextStep}
          id="signup-password--save"
        >
          {strings.next}
        </button>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/signup/components/SignupPassword.jsx